module.exports = __webpack_public_path__ + "img/image-4.ccdc1d0e.jpg";